import {
  Add_Commission_Pay_Type,
  Delete_Payment_Type,
  Get_Developer_Statement_Type,
  Get_Error,
  GetAll_Payments_For_Commission_Pay_Type,
  Update_Payment_Type,
} from '../Types';

const intial = {
  Add_Commission_Pay: [],
  Delete_Payment: [],
  Update_Payment: [],
  Get_Developer_Statement: [],
  loading: true,
};

const Commission_Pay_Reducer = (state = intial, action) => {
  switch (action.type) {
    case Add_Commission_Pay_Type:
      return {
        ...state,
        Add_Commission_Pay: action.payload,
        loading: false,
      };
    case Delete_Payment_Type:
      return {
        ...state,
        Delete_Payment: action.payload,
        loading: false,
      };
    case Update_Payment_Type:
      return {
        ...state,
        Update_Payment: action.payload,
        loading: false,
      };
    // developer statement كشف حساب ال developer
    case Get_Developer_Statement_Type:
      return {
        ...state,
        Get_Developer_Statement: action.payload,
        loading: false,
      };

    case Get_Error:
      return {
        loading: true,
        Add_Commission_Pay: action.payload,
      };
    default:
      return state;
  }
};

export default Commission_Pay_Reducer;
